import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import useFetchData from "../../../../../hooks/useFetchData";
import { DEFAULT_BASIC_WELL_INFO_STATE } from "../constants";
import { useStateIfMounted } from "use-state-if-mounted";

export const useBasicWellInfo = (selectedWell) => {
  const { getAccessTokenSilently } = useAuth0();

  const [editorState, setEditorState] = useStateIfMounted(
    DEFAULT_BASIC_WELL_INFO_STATE
  );
  const [isDirty, setIsDirty] = useStateIfMounted(false);

  const handleUpdateState = (name, value) => {
    if (!isDirty) setIsDirty(true);
    setEditorState((prevState) => {
      let newFilterValues = { ...prevState };
      if (name === "removed") {
        newFilterValues["should_remove"] = value;
      }
      newFilterValues[name] = value;
      return newFilterValues;
    });
  };

  const handleResetState = () => {
    setIsDirty(false);
    if (selectedWell) {
      setEditorState(data);
    } else {
      setEditorState(DEFAULT_BASIC_WELL_INFO_STATE);
    }
  };

  const { data, isFetching, error, refetch } = useQuery(
    ["list-wells", selectedWell],
    async () => {
      if (!selectedWell) {
        setIsDirty(false);
        setEditorState(DEFAULT_BASIC_WELL_INFO_STATE);
        return {};
      }
      try {
        const token = await getAccessTokenSilently();
        const headers = { Authorization: `Bearer ${token}` };

        const { data } = await axios.get(
          `${process.env.REACT_APP_ENDPOINT}/api/list-wells/${selectedWell}`,
          { headers }
        );
        setIsDirty(false);
        setEditorState(data);
        return data;
      } catch (err) {
        console.error(err);
      }
    },
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
    }
  );

  const [primaryWellUseLookup] = useFetchData(
    "ui-list-wm-primary-well-use",
    [],
    true
  );
  const [wellClassificationLookup] = useFetchData(
    "ui-list-wm-well-classification",
    [],
    true
  );
  const [wellSubClassLookup] = useFetchData(
    "ui-list-wm-well-subclass",
    [],
    true
  );

  return {
    data,
    isLoading: isFetching,
    error,
    refetch,
    isDirty,
    lookups: {
      primaryWellUse: primaryWellUseLookup,
      wellClassification: wellClassificationLookup,
      wellSubClass: wellSubClassLookup,
    },
    handleUpdateState,
    handleResetState,
    state: editorState,
    setter: setEditorState,
  };
};
